import RolesPage from './RolesPage'
import { rolesMenu } from './sideBarOption'

export { rolesMenu }
export default RolesPage
